import useAnalyticsCalls from '@/hooks/use-analytics';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// This hook enables page view reports to the analytics packages
export default function useAnalyticsPageViews() {
  const analytics = useAnalyticsCalls();
  const location = useLocation();
  const initialized = useRef('');

  useEffect(() => {
    if (!initialized.current || initialized.current !== location.pathname) {
      initialized.current = location.pathname;

      analytics.callPageView({
        page_name: location.pathname,
      });
    }
  }, [location.pathname, analytics]);
}
